import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { ChallengeLog } from "../../../types/Challenge";
import { getChallengeLogs } from "../../../api";
import { Loading, Markdown, Modal, unifyLanguageName } from "@quark/design";
import styles from "./index.module.scss";
import LogStatus from "./log-status";

interface CodeLogsProps {
  challengeId: number | string;
}

const CodeLogs: FC<CodeLogsProps> = ({ challengeId }) => {
  const [logs, setLogs] = useState<ChallengeLog[]>([]);
  const [loading, setLoading] = useState(false);
  const [curLog, setCurLog] = useState<ChallengeLog>();
  const [codeVisible, setCodeVisible] = useState(false);

  const code = useMemo(() => {
    const sourceCode = curLog?.source_code || "";
    const lang = unifyLanguageName(curLog?.language || "");
    return `\`\`\`${lang}\n${sourceCode}\n\`\`\``;
  }, [curLog]);

  const getLogs = useCallback(() => {
    setLoading(true);
    getChallengeLogs(Number(challengeId))
      .then((data) => {
        setLogs(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [challengeId]);

  useEffect(() => {
    if (!challengeId) return;
    getLogs();
  }, [challengeId, getLogs]);

  return (
    <div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>语言</th>
            <th>状态</th>
            <th>提交时间</th>
            <th>代码</th>
          </tr>
        </thead>
        {loading ? (
          <Loading />
        ) : (
          <tbody>
            {logs.map((log, index) => {
              return (
                <tr key={index}>
                  <td>{log.language}</td>
                  <td>
                    <LogStatus isPass={log.is_pass} />
                  </td>
                  <td>{log.created_at}</td>
                  <td>
                    <div
                      className={styles.button}
                      onClick={() => {
                        setCurLog(log);
                        setCodeVisible(true);
                      }}
                    >
                      查看
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        )}
      </table>
      {!logs.length && !loading && (
        <div className={styles.empty}>暂无提交记录</div>
      )}

      <Modal
        title={curLog?.created_at}
        visible={codeVisible}
        onClose={() => setCodeVisible(false)}
      >
        <div className={styles.code}>
          <Markdown>{code}</Markdown>
        </div>
      </Modal>
    </div>
  );
};

export default CodeLogs;
